ch-segmented-control-render {
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}